// @ vendor
const classnames = require('classnames');

// @ utilities
const { toFirstUppercase } = require('utilities/stringHelper');
const { formatText } = require('core/i18n').i18n;

// @ constant
const { THIRD_STEP } = require('constants/index');
const { INSURANCE_STATE } = require('../../insuranceConstants/insuranceRequestHome');

const insuranceRequestBuildPlanItem = (
    immInsuranceState,
    hasSimulation,
    hasSimulationChanged,
    immInsuranceWizardState
) => {
    const selectedPlan = immInsuranceWizardState.getIn(['steps', THIRD_STEP, 'insurancePlan']);
    const plan = immInsuranceState.getIn(['data', 'insurancePlan']) || '';
    const selectedPlanTemp = formatText(`insuranceRequestHome-insuranceType${toFirstUppercase(selectedPlan)}`);
    const summaryToBeDefined = formatText('insuranceRequestHome-summaryToBeDefined');
    let planFormattedText = selectedPlan && !hasSimulationChanged ? selectedPlanTemp : summaryToBeDefined;
    const invalidSimulation = immInsuranceState.getIn(['data', 'insuranceState']) === INSURANCE_STATE.INVALID;

    if (plan && hasSimulation && !hasSimulationChanged && !invalidSimulation) {
        planFormattedText = selectedPlanTemp || formatText(`insuranceRequestHome-insuranceType${toFirstUppercase(plan)}`);
    }

    let showDisabled = !hasSimulation || hasSimulationChanged || !selectedPlan;

    return {
        label: formatText('insuranceRequestHome-summaryInsuranceType'),
        text: planFormattedText,
        className: classnames({
            'insurance-request-compilation-card__text--disabled': showDisabled
        })
    };
}

module.exports = insuranceRequestBuildPlanItem;
